import { IsEnum, IsNotEmpty, IsNumber, IsOptional, ValidateIf } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { FarmTypesEnum, HarvestTypes, PlantsEnum, RMInwardTypeEnum, SupplierTypeEnum, VehicleTypeEnum } from '@gtpl/shared-models/common-models';
import { CommissionType, HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { IndentItemsModel } from './indent-items.model';
import { FarmTypeEnum } from '@gtpl/shared-models/masters';
export class IndentDetailsDto {
    @ApiProperty()
    // @IsEnum(PlantsEnum)
    plantId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Indent Date should not be empty" })
    indentDate: Date;

    @ApiProperty({
        enum: SupplierTypeEnum
    })
    @IsNotEmpty({ message: "Supplier Type should not be empty" })
    @IsEnum(SupplierTypeEnum)
    supplierType: SupplierTypeEnum;

    @ApiProperty({
        enum: CommissionType
    })
    @IsOptional()
    @IsEnum(CommissionType)
    commissionType: CommissionType;

    @ApiProperty()
@IsOptional()
    @IsNumber()
    commission: number;

    @ApiProperty()
    @IsOptional()
    harvestingDate: Date;

    @ApiProperty({
        enum: HarvestingTime
    })
    @IsOptional()
    @IsEnum(HarvestingTime)
    harvestingTime: HarvestingTime;

    @ApiProperty()
    @IsOptional()
    indentBy: number;

    @ApiProperty()
    assignLead1: number;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    assignLead2: number;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    indentId: number;

    @ApiProperty()
    @IsOptional()
    indentCode: string;

    @ApiProperty()
    @IsOptional()
    grnCompleted: boolean;

    @ApiProperty({
        enum: HarvestTypes
    })
    @IsNotEmpty({ message: "Supplier Type should not be empty" })
    @IsEnum(HarvestTypes)
    harvestType: HarvestTypes;
    @ApiProperty({ type: [IndentItemsModel] })
    indentItems: IndentItemsModel[];

    @ApiProperty()
    @IsOptional()
    createdUser: string;

    @ApiProperty()
    @IsOptional()
    isVehicleRequired: boolean;

    @ApiProperty()
    @IsOptional()
    updatedUser: string;

    @ApiProperty()
    @IsOptional()
    isActive: boolean;

    @ApiProperty()
    farmType: FarmTypesEnum;

    @ApiProperty()
    @IsOptional()
    rmInwardType: RMInwardTypeEnum;

    @ApiProperty()
    @ValidateIf((o) => o.rmInwardType === RMInwardTypeEnum.IMPORT)
    @IsNotEmpty({ message: 'BOE Number is mandatory for Import' })
    boeNum: string;

    @ApiProperty()
    @ValidateIf((o) => o.rmInwardType === RMInwardTypeEnum.IMPORT)
    @IsNotEmpty({ message: 'BOE Date is mandatory for Import' })
    boeDate: Date;
}